module.exports = __webpack_public_path__ + "static/media/purpose_image2.8fbbec3b.png";